import { Button } from 'antdV3';
import { COLOR_OPTIONS } from 'config/style';
import { BREAKPOINTS } from 'config/style/breakpoints';
import styled from 'styled-components';

export const FooterContainer = styled.footer`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 24px 40px 32px 24px;
  pointer-events: none;
  z-index: 999;

  @media (min-width: ${BREAKPOINTS.MOBILE + 1}px) {
    display: none;
  }
`;

export const ReportFloatingButton = styled(Button)`
  pointer-events: auto;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background-color: ${COLOR_OPTIONS.GREEN_60};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;

  &:hover {
    background-color: ${COLOR_OPTIONS.GREEN_60};
    transform: scale(1.05);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  }

  &:active {
    background-color: ${COLOR_OPTIONS.GREEN_70};
    transform: scale(0.95);
  }

  svg {
    fill: ${COLOR_OPTIONS.WHITE};
  }
`;

export const SideMenuFloatingButton = styled(ReportFloatingButton)`
  background-color: ${COLOR_OPTIONS.WHITE};
  border: 1px solid ${COLOR_OPTIONS.NEUTRAL_30};
  position: absolute;
  left: 24px;
  top: 50%;
  transform: translateY(-50%);

  svg {
    color: ${COLOR_OPTIONS.NEUTRAL_90};
  }
  svg path {
    fill: currentColor;
  }
  &:hover,
  &:focus-visible {
    border-color: ${COLOR_OPTIONS.NEUTRAL_50};
    background-color: ${COLOR_OPTIONS.NEUTRAL_10};
    svg {
      color: ${COLOR_OPTIONS.NEUTRAL_40};
    }
  }
`;
